import { useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { getCampaigns } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";

import { LAUNCH_OS_ICON } from "@/brand";
export const Partnerships = ({ name = "" }) => {
  const [partnerPrograms, setPartnerPrograms] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // get the list of Partnership Programs from the server
  const loadPartnerPrograms = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "partnership" });
    // const response = await getCampaigns({ token, type: "partnerProgram" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((partnerProgram: any) => {
          return {
            id: partnerProgram.id,
            label: partnerProgram.name,
            caption: `Last Updated: ${moment(
              partnerProgram.updatedAt
            ).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setPartnerPrograms(seqs);
    }
    setIsLoading(false);
  };

  // load the partnerPrograms when the page loads
  useEffect(() => {
    loadPartnerPrograms();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Link to="/launchpad/partnerships" className="justify-end">
            <Button
              label="+ Create a Partnership Program"
              type={ButtonTypes.OUTLINED}
            />
          </Link>
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(partnerPrograms.length) && (
          <EmptyState
            title="No Partnership Programs Yet"
            description="Get started by creating a new partnership program."
            showImage={false}
          >
            <Link to="/launchpad/partnerships">
              <Button
                label="Create a Partnership Program"
                type={ButtonTypes.DEFAULT}
              />
            </Link>
          </EmptyState>
        )}
        {!isLoading && Boolean(partnerPrograms.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {partnerPrograms.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/partnerships/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
